import type { VideoRecord } from "../types/domain";

export const VIDEO_STATUS_SEQUENCE = ["idea", "script", "production", "qa", "published"] as const;
export type VideoStatusKey = (typeof VIDEO_STATUS_SEQUENCE)[number];

const STATUS_ALIASES: Record<string, VideoStatusKey> = {
  idea: "idea",
  "идея": "idea",
  script: "script",
  "сценарий": "script",
  production: "production",
  "продукция": "production",
  qa: "qa",
  published: "published",
  "публикувано": "published",
};

export function videoStatusKey(status: string): VideoStatusKey {
  return STATUS_ALIASES[status.trim().toLocaleLowerCase("bg")] ?? "idea";
}

export function nextVideoStatus(status: string): VideoStatusKey {
  const current = VIDEO_STATUS_SEQUENCE.indexOf(videoStatusKey(status));
  return VIDEO_STATUS_SEQUENCE[Math.min(current + 1, VIDEO_STATUS_SEQUENCE.length - 1)];
}

export function createVideoRecord(input: {
  title: string;
  audience: string;
  status: VideoStatusKey;
  goal: string;
  pillar: string;
}): VideoRecord {
  const now = new Date().toISOString();
  return {
    id: crypto.randomUUID(),
    audience: input.audience,
    title: input.title.trim(),
    batch: "",
    status: input.status,
    pillar: input.pillar.trim(),
    funnel: "",
    claim_risk: "low",
    goal: input.goal.trim(),
    pain: "",
    belief_shift: "",
    mechanism: "",
    proof: "",
    cta: "",
    hook_id: null,
    hook_file: "",
    hook_target: "",
    bridge: "",
    script: "",
    duration: "",
    visuals: "",
    overlay_text: "",
    audio: "",
    raw_file: "",
    export_file: "",
    platform: "",
    publish_date: null,
    caption: "",
    cover: "",
    post_url: "",
    learning: "",
    created_at: now,
    updated_at: now,
  };
}
